<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.benefitwhiz.com/"
        target="_blank">Benefit Whiz</a>, made with
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard' },
      { name: 'Privacy Policy', Link: 'https://www.benefitwhiz.com/privacypolicy' },
      { name: 'About Us', Link: 'https://www.benefitwhiz.com/aboutus' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
